<div [class]="classes?.sectionWrap">
    <div [class]="classes?.sectionInner" [ngClass]="{'mobile-section': isMobileContainerSection}">
        <ng-content></ng-content>
    </div>
</div>
